import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Container, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import MultipleSelect from "component/MultipleSelect/MultipleSelect";
import { InputLabel } from "@mui/material";
import { FormControl } from "@mui/material";
import * as Yup from "yup";
import { NavLink, Link } from "react-router-dom";
import Header from "component/HeaderBackoffice/HeaderBackoffice";
import { getAllEmpresas, printXl /* printXlAll */ } from "component/api";
import withRouter from "component/utilies/withRouter";
import "./BackofficeAysaLogeado.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function BackofficeAysaLogeado(props) {
  const welcome = <Typography variant="p">Bienvenido!</Typography>;
  const backoffice = <Typography variant="p"></Typography>;
  const [clientWidth, setClientWidth] = useState("");
  const [errorEmpresa, setErrorEmpresa] = useState("");

  const logeado = sessionStorage.getItem("logeado");
  const button = (
    <NavLink to="/backoffice" style={{ textDecoration: "none" }}>
      <Button
        style={{ backgroundColor: "#FF3E00", color: "white" }}
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
        }}
        variant="contained"
      >
        <Typography
          style={{
            fontSize: "16pt",
            textTransform: "none",
            fontFamily: "Roboto",
            fontWeight: "bold",
          }}
        >
          Salir
        </Typography>
      </Button>
    </NavLink>
  );

  const validation = Yup.object({
    empresas: Yup.string().required("requerido"),
    fechaDesde: Yup.string().required("requerido"),
    fechaHasta: Yup.string().required("requerido"),
  });

  const formik = useFormik({
    initialValues: {
      empresas: [],
      fechaDesde: "",
      fechaHasta: "",
    },
    validationSchema: validation,
  });

  const [empresas, setEmpresas] = useState([]);

  async function getAllEmpresasFunc() {
    const res = await getAllEmpresas();
    setEmpresas(res.data);
  }

  function print() {
    if (localStorage.getItem("empresasId") === "") {
      setErrorEmpresa(" ");
    } else if (localStorage.getItem("empresasId") !== "") {
      try {
        let empresaArray = [];
        let empresaArrayLong = [];
        empresaArray.push(localStorage.getItem("empresasId"));
        for (let i = 0; i < empresaArray.length; i++) {
          empresaArrayLong.push(parseInt(empresaArray[i]));
        }
        printX(
          parseInt(localStorage.getItem("empresaId")),
          formik.values.fechaDesde,
          formik.values.fechaHasta
        );
        setErrorEmpresa("");
      } catch (err) {
        console.log(err);
      }
    }
  }

  async function printX(empresaId, fechaDesde, fechaHasta) {
    await printXl(
      localStorage.getItem("empresasId"),
      fechaDesde,
      fechaHasta
    ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "reporteMovimiento.xls");
      document.body.appendChild(link);
      link.click();
    });
  }

  useEffect(() => {
    try {
      getAllEmpresasFunc();
      setClientWidth(document.documentElement.clientWidth);
      window.history.replaceState(null, null, "/backOffice/reporte");
    } catch (err) {
      console.log(err);
    }
  }, []);

  const width = clientWidth > 415 ? "45%" : "80%";
  return (
    <Container fixed>
      <div>
        <Header welcome={welcome} button={button} backoffice={backoffice} />
        {logeado === "true" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Grid container sx={{ width: "100%" }} style={{ marginLeft: "2%" }}>
              <Grid size={{ xs: 4 }}>
                <Link to="/backOfficeL" style={{ textDecoration: "none" }}>
                  <Button
                    startIcon={<ArrowBackIcon />}
                    style={{
                      textTransform: "none",
                      backgroundColor: "white",
                      color: "#009BDB",
                    }}
                  >
                    Volver
                  </Button>
                </Link>
              </Grid>
              <Grid size={{ xs: 8 }}>
                <form
                  onSubmit={formik.handleSubmit}
                  style={{ alignSelf: "center", width: width, marginTop: "2%" }}
                >
                  <div style={{ alignSelf: "center", marginTop: "2%" }}>
                    <FormControl className="form-control__backoffice-aysa-log">
                      <MultipleSelect title={"Empresas"} error={errorEmpresa} />
                    </FormControl>
                  </div>
                  <FormControl className="form-control__backoffice-aysa-log">
                    <InputLabel
                      style={{ fontSize: "16pt", fontFamily: "Roboto" }}
                    >
                      Fecha (desde)
                    </InputLabel>
                    <TextField
                      className="text-field__backoffice-aysa-log"
                      id="fechaDesde"
                      type="date"
                      value={formik.values.fechaDesde}
                      onChange={formik.handleChange}
                      helperText={formik.errors.fechaDesde}
                      error={!!formik.errors.fechaDesde}
                    />
                  </FormControl>

                  <FormControl className="form-control__backoffice-aysa-log">
                    <InputLabel
                      style={{ fontSize: "16pt", fontFamily: "Roboto" }}
                    >
                      Fecha (hasta)
                    </InputLabel>
                    <TextField
                      className="text-field__backoffice-aysa-log"
                      id="fechaHasta"
                      type="date"
                      value={formik.values.fechaHasta}
                      onChange={formik.handleChange}
                      helperText={formik.errors.fechaHasta}
                      error={!!formik.errors.fechaHasta}
                    />
                  </FormControl>

                  <div>
                    <Button
                      style={{
                        marginLeft: "3%",
                        fontSize: "16pt",
                        textTransform: "none",
                        fontWeight: "bold",
                        fontFamily: "Roboto",
                        backgroundColor: "#0055a6",
                        marginTop: "30px",
                        width: "100%",
                        marginBottom: "30px",
                      }}
                      id="buttom"
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        print();
                        // setErrorEmpresa("");
                      }}
                    >
                      {" "}
                      Descargar reporte
                    </Button>
                  </div>
                </form>
              </Grid>
            </Grid>
          </div>
        )}
        {logeado === null && (
          <div style={{ marginLeft: "10%", marginTop: "4%" }}>
            <h2>Por favor iniciar la sesión .</h2>
          </div>
        )}
      </div>
    </Container>
  );
}
export default withRouter(BackofficeAysaLogeado);
